import { FolderIcon } from "@heroicons/react/24/solid";
import moment from "moment";
import React from "react";
import { formatFileSize } from "src/helpers/cmsHelper";
import { getFileIcon } from "src/helpers/documentHelper";

const DocumentDefaultView = ({ pageName, documents, onDocumentClick }) => {
  const docIds = new Set((documents || []).map((d) => (d?._id || d?.id)?.toString()).filter(Boolean));
  const filteredDocuments =
    documents?.filter((doc) => {
      const pId = (doc?.parent_id || doc?.parentId)?.toString();
      return !pId || !docIds.has(pId);
    }) || [];

  return (
    <div className="w-full bg-white">
      <div className="border-b border-gray-200 px-8 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div>
              <h1 className="text-2xl font-semibold">{pageName}</h1>
            </div>
            <p className="mt-1 rounded-full border px-3 py-1 text-sm text-gray-500">{filteredDocuments?.length > 0 ? `${filteredDocuments.length} document${filteredDocuments.length !== 1 ? "s" : ""}` : "Empty folder"}</p>
          </div>
        </div>
      </div>
      <div className="w-full bg-white">
        <div className="hidden grid-cols-12 gap-4 border-b border-gray-200 bg-gray-50 px-8 py-3 font-semibold text-gray-700 sm:grid">
          <div className="col-span-7 flex items-center">
            <span>Name</span>
          </div>
          <div className="col-span-3 flex items-center">
            <span>Last modified</span>
          </div>
          <div className="col-span-1 flex items-center">
            <span>File size</span>
          </div>
        </div>
        <div className="grid divide-y divide-gray-200 px-4 sm:px-6">
          {filteredDocuments?.map((doc) => (
            <div
              key={doc._id}
              onClick={() => onDocumentClick?.(doc)}
              className="group flex cursor-pointer grid-cols-12 flex-wrap gap-1 py-4 transition-colors hover:bg-gray-50 sm:-mx-5 sm:grid sm:flex-nowrap sm:gap-4 sm:px-7">
              <div className="flex w-full max-w-full items-center space-x-3 sm:col-span-7 sm:w-auto">
                <div className="text-xl sm:flex-shrink-0">{doc?.type === "folder" ? <FolderIcon className="h-5 w-5 text-amber-500" /> : getFileIcon(doc.extension)}</div>
                <div className="min-w-0 flex-1">
                  <div className="line-clamp-2 text-sm font-semibold !leading-tight text-gray-900 transition-colors group-hover:text-blue-600 sm:line-clamp-none sm:truncate">
                    {doc.name}.{doc.extension}
                  </div>
                </div>
              </div>
              <div className="flex items-center pl-8 sm:col-span-3 sm:pl-0">
                <span className="text-sm text-gray-600">{moment(doc.created_at).format("MMM D, YYYY, hh:mm A")}</span>
              </div>
              <div className="ml-auto flex items-center sm:col-span-1 sm:m-0">
                <span className="text-sm text-gray-600"> {doc?.type === "folder" ? "-" : formatFileSize(doc?.size_in_bytes)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {filteredDocuments?.length === 0 && (
        <div className="flex flex-col items-center justify-center py-20">
          <div className="mb-6">
            <svg
              className="h-24 w-24 text-gray-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
          </div>
          <h3 className="mb-2 text-xl font-medium text-gray-900">This folder is empty</h3>
          <p className="max-w-sm text-center text-gray-500">Drop files here or use the "New" button to upload</p>
        </div>
      )}
    </div>
  );
};

export default DocumentDefaultView;
